import axios from 'axios';
import { env, func, types } from '.';

const clearUserData = () => {
    func.delStorage('user');
    func.delStorage('token');
    func.redirect('/');
}

export const signout = () => {
    const v = func.getStorageJson('user') as types.User;
    if (v.id) {
        put(`users/me`, { preferences: { online: false, offlineFor: 3600,} }).then((res: types.AxiusResponse) => {
            clearUserData();
        });
    }
}

export const apnData = (obj: any) => {
    const body = new FormData();
    for (var p in obj) {
        if (p === 'file') {
            body.append('file', obj[p]);
        } else {
            body.append(p, obj[p]);
        }
    }
    return body;
}

export const apiHeaders = (type: string = ''): any => {
    const token = func.getStorage('token') || '';
    if (type === 'file') {
        return {
            'Accept': 'application/json',
            'x-access-token': `${token}`
        };
    } else {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': `${token}`,
        };
    }
}

export const checkFullURL = (action: string) => {
    if (action.indexOf('http://') > -1 || action.indexOf('https://') > -1) {
        return action;
    }
    return env.API_URL + action;
}

export const get = async (action: string, data = {}) => {
    let headers = apiHeaders();
    let url = checkFullURL(action);
    return axios({
        method: 'GET', url,
        headers,
        params: data,
    }).then(response => {
        return respunse(response.data, response.status);
    }).catch(error => {
        const response = error.response;
        return respunse(response?.data, response?.status);
    });
}

export const post = async (action: string, data = {}) => {
    let url = checkFullURL(action);
    let headers = apiHeaders();
    return axios({
        method: 'POST', url,
        headers,
        data,
    }).then(response => {
        return respunse(response.data, response.status);
    }).catch(error => {
        const response = error.response;
        return respunse(response?.data, response?.status);
    });
}

export const put = async (action: string, data = {}) => {
    let url = checkFullURL(action);
    let headers = apiHeaders();
    return axios({
        method: 'PUT', url,
        headers,
        data,
    }).then(response => {
        return respunse(response.data, response.status);
    }).catch(error => {
        const response = error.response;
        return respunse(response?.data, response?.status);
    });
}

export const delte = async (action: string, data = {}) => {
    let url = checkFullURL(action);
    let headers = apiHeaders();
    try {
        let response = await fetch(url, {
            method: 'DELETE',
            headers,
            body: JSON.stringify(data),
        });
        return respunse(await response.json(), response.status);
    } catch (error) {
        return { status: 606, result: 'Network request failed', error: error };
    }
}

export const postFile = async (action: string, data = {}) => {
    let url = checkFullURL(action);
    let headers = apiHeaders('file');
    try {
        let response = await fetch(url, {
            method: 'POST',
            headers,
            body: apnData(data),
        });
        return respunse(await response.json(), response.status);
    } catch (error) {
        return { status: 606, result: 'Network request failed', error: error };
    }
}

const respunse = (res: any, status: number) => {
    if ([505, 401, 403].includes(status) && func.getStorageJson('user').id) {
        signout();
        return res;
    } else if (status === 412) {
        res['message'] = res?.data ? res?.data.join(' | ') : res?.message;
    }
    return { ...res, status, message: res?.message || 'Something went wrong' };
}